module.exports = __webpack_public_path__ + "img/home-hero-pattern-bottom.97a81f81.png";